import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import DashBoardSideBar from "../navigation/dashBoardSideBar"
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import DashboardLoadingLayout from './DashboardLoadingLayout';
import 'react-responsive-pagination/themes/classic.css';
import { FiShoppingBag } from "react-icons/fi";
import { TbWorldCheck } from "react-icons/tb";
import { LogoutApp } from '../../utils/logout';
 

function DashboardLayout(props) {
   let navigate = useNavigate();
   let profile = useSelector(data => data.profile?.data);
   let pending = useSelector(data => data.pending?.data);
   let status = JSON.parse(localStorage.getItem("sideBar-status"))
   let [sidebar, setSidebar] = useState(status || false)

   let handelSideBar = () => {
      setSidebar(!sidebar)
      localStorage.setItem("sideBar-status", !sidebar);
   }
   useEffect(() => {
      const token = localStorage.getItem("token")
      if (!token) {
         navigate("/");
      }
   }, [])

   return (
      <>
         <DashboardLoadingLayout>
            <div className={`${sidebar ? '' : 'close'} nav-container`}>
               <div className="sid-bar">
                  <div className="log-wrapper p-3">
                     <img src={profile?.setting?.websiteLogo ? profile?.setting?.websiteLogo : "/assets/images/logo-placeholder.png"} alt="admin-log" height="100%" />
                  </div>
                  <div className="profile-wrapper">
                     <div>
                        <h4 className='mb-1'>{profile?.name}</h4>
                        <p className='text-muted'>{profile?.email}</p>
                     </div>
                  </div>
                  <DashBoardSideBar updateSideBar={handelSideBar} />
                  {/* logout */}
                  <div className="logout-wrapper">
                     <button className="btn btn-dark w-100 rounded-0" onClick={() => {
                        LogoutApp()
                     }}>Logout</button>
                  </div>
               </div>
               <div className="top-bar m-0">
                  <div className="left-side">
                     <i className="fas fa-bars" onClick={handelSideBar}></i>
                  </div>
                  <div className="right-side">
                     <div className="app-top-bar text-center ">
                        {/* <div>
                           <div className="notificationBell">
                              <i className="far fa-telescope"></i>
                              <span>12</span>
                           </div>
                        </div>
                        <div>
                           <div className="notificationBell">
                              <i className="far fa-user-cog"></i>
                              <span>1</span>
                           </div>
                        </div>
                        <div>
                           <div className="notificationBell">
                              <i className="fas fa-bell me-2"></i>
                              <span>4</span>
                           </div>
                        </div> */}
                        <a href={"https://" + profile?.domain} target='_blank'>
                           <div className="notificationBell">
                              <TbWorldCheck />
                           </div>
                        </a>
                        <div className=''>
                           <Link to="/dashboard/order">
                              <div className="notificationBell">
                                 <FiShoppingBag />
                                 <span>{pending?.pendingOrders}</span>
                              </div>
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="app-container">
                  {props.children}
               </div>
            </div>
         </DashboardLoadingLayout>
      </>
   );
}

export default DashboardLayout